import { Dayjs } from 'dayjs'

// Same shape the Job Costing filters post to graphing/financials-data, so every
// dashboard report speaks one filter vocabulary. null means "not filtered".
export type DashboardFilters = {
  divisionIds: string[] | null
  salesPersonEmails: string[] | null
  crewForemanEmails: string[] | null
}

export const noDashboardFilters: DashboardFilters = {
  divisionIds: null,
  salesPersonEmails: null,
  crewForemanEmails: null,
}

// The header picks whole days, but the reports compare timestamps against the end date's midnight and so
// dropped the end day. Sending the end of that day makes every report include it.
export const dashboardRangeEnd = (end: string): string => end ? `${end} 23:59:59` : end

export const hasDashboardFilters = (filters: DashboardFilters): boolean =>
  Object.values(filters).some(values => !!values?.length)

// The API binds repeated params (divisionIds=1&divisionIds=2), not axios's default divisionIds[]=1.
export const dashboardFiltersQuery = (filters: DashboardFilters): URLSearchParams => {
  const query = new URLSearchParams()
  ;(Object.entries(filters) as [string, string[] | null][])
    .forEach(([name, values]) => (values ?? []).forEach(value => query.append(name, value)))
  return query
}

export type DashboardDatePreset = {
  label: string
  value: [Dayjs, Dayjs]
}

// One-click time periods for the dashboard date range (SYN-4031).
export const dashboardDatePresets = (today: Dayjs): DashboardDatePreset[] => {
  const quarterStart = today.startOf('month').month(Math.floor(today.month() / 3) * 3)
  const lastMonth = today.subtract(1, 'month')
  const lastYear = today.subtract(1, 'year')

  return [
    { label: 'This month', value: [today.startOf('month'), today] },
    { label: 'Last month', value: [lastMonth.startOf('month'), lastMonth.endOf('month')] },
    { label: 'This quarter', value: [quarterStart, today] },
    { label: 'Year to date', value: [today.startOf('year'), today] },
    { label: 'Last year', value: [lastYear.startOf('year'), lastYear.endOf('year')] },
  ]
}
